import { CardsViewAttributeOption, CardsViewSortOption } from "@organisms/ObjectsView/CardsView/CardsView.types"

export const CLIENT_CARDS_VIEW_ATTRIBUTE_OPTIONS: CardsViewAttributeOption<Client>[] = [
    { name: "credit_limit", label: "Credit Limit" },
    { name: "service_locations_count", label: "Service Locations" },
    { name: "default_invoice_net", label: "Terms" },
    { name: "industry_type_label", label: "Industry Type" },
    { name: "last_modified_at", label: "Last Modified" },
    { name: "labels", label: "Labels" },
]

export const CLIENT_CARDS_VIEW_SORT_OPTIONS: CardsViewSortOption<Client>[] = [
    { name: "name", label: "Client" },
    { name: "client_type_label", label: "Type" },
    { name: "bills_to", label: "Bills To" },
    { name: "default_invoice_net", label: "Terms" },
    { name: "credit_limit", label: "Credit Limit" },
    { name: "last_modified_at", label: "Last Modified" },
]
